module.exports = "<b-form @submit=\"handleSubmit\">\n    <slot :form=\"form\" :state=\"formState\"></slot>\n</b-form>\n"